"use client";
import t from "styled-components";
const p = t.div`
  position: absolute;
  left: -9999px;
  top: -9999px;
  width: 900px;
`;
export {
  p as default
};
//# sourceMappingURL=index.es84.js.map
